module.exports = __webpack_public_path__ + "media/images/web_atm_img-211b8a5e7e810931d65ffeef6ba0b076.png";